import { useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import {ReactComponent as Logo} from '../../assets/images/ugcan-logo.svg';
import { useUser } from '../store/UserContext';
import CandidateRegistration from '../Authentication/CandidateRegistration';
import ForgotPassword from '../Authentication/ForgotPassword';
import {Icon} from 'react-icons-kit';
import {eyeOff} from 'react-icons-kit/feather/eyeOff';
import {eye} from 'react-icons-kit/feather/eye';


const CandidateLogin = ({closeModal}) => {
  // Fallback for when used as a route without closeModal prop
  const handleClose = () => {
    if (typeof closeModal === 'function') {
      closeModal();
    } else {
      // If no closeModal prop, navigate back or to home
      navigate('/');
    }
  };
  const BASE_URL = process.env.REACT_APP_AUTH_URL;
  const navigate = useNavigate();
  const { user, setUser } = useUser();  // Use setUser from context
  const [loginMode, setLoginMode] = useState('email'); // 'email' | 'handle'
  const [form, setForm] = useState({email: '', handleId: '', password: '', rememberMe: false});
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [error, setError] = useState('');
  const [type, setType] = useState('');
  const [loading, setLoading] = useState(false);
  const [showRegistration, setShowRegistration] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [icon, setIcon] = useState(eyeOff);
  const buttonClass = `m-2 p-2 h-10 w-fit 
                      bg-primary-900/30 text-primary-900 hover:text-white hover:bg-primary-900 
                      border-2 rounded-lg 
                      text-base font-bold tracking-widest normal-case items-center
                      rounded-full shadow-md transition`
  const closeButtonClass = `absolute top-2 right-2 w-8 h-8 flex items-center justify-center font-bold text-xl
                           bg-transparent text-primary-900 hover:text-white hover:bg-primary-900 
                           border-2 rounded-lg shadow-lg transition-colors z-20`
  const fieldClass = "w-full bg-tertiary-400 m-1 p-2 text-sm font-nunito placeholder:text-gray-500 rounded"
  // Handle input field changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === 'checkbox' ? checked : value,
    });
  };
  const handleCheckboxChange = () => {
    setForm({
      ...form,
      rememberMe: !form.rememberMe,  // Toggle the rememberMe checkbox value
    });
  };
  // console.log(form)
  // Handle login form submission
  const handleLogin = async (e) => {
    e.preventDefault();
    let response;
    let userResponse;
    let access;
    let refresh;
    try {
        // Send a login request to the backend - always use email field but populate with email or HandleID
        const payload = { 
          email: loginMode === 'email' ? form.email : form.handleId, 
          password: form.password 
        };
        
        response = await axios.post(`${BASE_URL}/api/auth/jwt/create/`, payload,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        access = response?.data?.access;
        refresh = response?.data?.refresh;
        // console.log(access)
        // console.log(refresh)
        // console.log(rememberMe)
        if (form.rememberMe) {
          localStorage.setItem('access_token', access);
          localStorage.setItem('refresh_token', refresh);
        } else {
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          sessionStorage.setItem('access_token', access);
          sessionStorage.setItem('refresh_token', refresh);
        }
        setError('');
      } catch (error) {
        console.log(error)
        if (error.response) {
            const {data} = error.response;
            console.log(data)
            const errorMessage = data?.detail === 'No active account found with the given credentials' ? data?.detail +  ' If you haven’t activated your account yet, please check your email for the activation link' : 'Error: An unknown error occurred'
            return setError(errorMessage);
        } else if (error.request) { // An error occurred while setting up the request
          // The request was made but no response was received
          return setError('Network error: No response from server');
        } else {         
          return setError('Error: Something went wrong during login. Please try again after some time.');
        }
      }
      // If successful, 
      if (access) {
          try {
                userResponse = await axios.get(`${BASE_URL}/auth/users/me/`, {
                 headers: {
                   Authorization: `Bearer ${response.data.access}`
                 }
               });
          } catch (error) {
            if (error.response) {
                // Server responded with an error
                setError(`Login failed: ${error.response.data?.detail || 'Unknown error'}`);
            } else if (error.request) {
                // The request was made but no response was received
                setError('Network error: No response from server');
            } else {
                // An error occurred while setting up the request
                setError('Error: Something went wrong during login. Please try again after some time');
            }
          };
      };
      if (userResponse?.data) {  
        // Set the user data to state
        console.log(userResponse.data)
        setUser({
          username: userResponse.data.username,
          email: userResponse.data.email,
          colorhex: userResponse.data.usercolorhex,
          id: userResponse.data.id
        });
        setError('');
      
        // Close the login modal and show success message
        handleClose();
        navigate("/"); // works in modal context
      };
  };
    
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post(`${BASE_URL}/auth/users/reset_password/`, {
        email: form.email,
      });
      setEmailSent(true);
    } catch (err) {
      console.log(err.response)
      if (err.response) {
        setError(`Could not send reset link - ${err.response.data}`);
      } else {
        setError(`Could not send reset link. - ${err.message}`);
      }
      
    }
    setLoading(false);
  };
  
  const handleRegistration = () => {
    setShowRegistration(true);
  };

  const handleToggleEyeIcon = () => {
    if (type==='password'){
       setIcon(eye);
       setType('text')
    } else {
       setIcon(eyeOff)
       setType('password')
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        handleClose(); // Close the modal
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    
    // Cleanup on unmount
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [closeModal]);
  console.log(error)
  console.log(user)
  console.log('CANDIDATE LOGIN RENDERED - RED BUTTON SHOULD BE VISIBLE')
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="modal-content w-full max-w-sm p-6 bg-primary-100 white rounded-lg shadow-lg space-y-4 relative">
          <div className="w-full max-w-sm p-6 rounded-lg shadow-lg space-y-4 bg-tertiary-600 relative">
                         {/* Close button */}
             <button
               onClick={handleClose}
               className={closeButtonClass}                
               aria-label="Close"
             >
               X
             </button>
                <div className="flex justify-center items-center w-full"><Logo/></div>
                <div className="flex justify-center items-center w-full">
                      {error && <p className="flex text-red-500 text-center">{error}</p>}
                </div>
                <div className="flex justify-center items-center w-full">
                      {isForgotPassword ? (
                          <form id='forgotpassword' onSubmit={handleForgotPassword}>
                            {emailSent && <p className="text-red-500 text-base text-center">Reset link sent!</p>}
                            <h2 className="text-lg font-semibold text-secondary-900 mt-2 mb-2">Forgot your password?</h2>
                            <input
                              type="email"
                              name="email"
                              value={form.email}
                              onChange={handleChange}
                              placeholder="Enter your email"
                              required
                              className={`${fieldClass}`}
                            />

                            <button
                              type="submit"
                              className={`${buttonClass} w-full py-2 rounded mt-2`}
                              disabled={loading}
                              data-cy="forgotpassword"
                            >
                              {loading ? 'Sending...' : 'Send Reset Link'}
                            </button>
                            <p
                              onClick={() => setIsForgotPassword(false)}
                              className="mt-4 text-sm text-secondary-900 hover:underline cursor-pointer"
                            >
                              ← Back to login
                            </p>
                          </form>
                      ) : (
                          <form id='login' onSubmit={handleLogin} className="w-full text-center">
                            {user && <p className="text-red-500 text-center">Welcome {user.username}!</p>}
                            <div className="flex flex-col text-center justify-center">
                              
                              {/* Email or HandleID input */}
                              {loginMode === 'email' ? (
                                <input
                                  type="email"
                                  id="email"
                                  name="email"
                                  value={form.email}
                                  onChange={handleChange}
                                  placeholder='Email'
                                  required
                                  autoComplete="new-password"
                                  className = {`${fieldClass} w-full`}
                                />
                              ) : (
                                <input
                                  type="text"
                                  id="handleId"
                                  name="handleId"
                                  value={form.handleId}
                                  onChange={handleChange}
                                  placeholder='HandleID'
                                  required
                                  autoComplete="new-password"
                                  className = {`${fieldClass} w-full`}
                                />
                              )}
                              <div className="w-full text-center">
                              <p
                                    onClick={() => setLoginMode(loginMode === 'email' ? 'handle' : 'email')}
                                    className="text-sm text-gray-500 hover:underline font-nunito cursor-pointer mb-4"
                                >
                                    {loginMode === 'email' 
                                      ? 'Login with HandleID'
                                      : 'Login with Email'}
                              </p>
                              </div>
                              
                              {/* Password input */}
                              <label className="w-full relative">
                                <input
                                  type={type}
                                  id="password"
                                  name="password"
                                  value={form.password}
                                  onChange={handleChange}
                                  placeholder='Enter your Password'
                                  required
                                  autoComplete="new-password" 
                                  className = {`${fieldClass} pr-10`}
                                />
                                <span 
                                    className="absolute inset-y-0 right-3 flex items-center cursor-pointer"
                                    onClick={handleToggleEyeIcon}>
                                    <Icon icon={icon} size={22}/>
                                </span>
                              </label>
                            </div>
                            {/* Remember Me checkbox */}
                            <div className="flex items-center gap-2 mt-4 mb-4 ml-1 align-middle">
                              <input
                                type="checkbox"
                                id="rememberMe"
                                name="rememberMe"
                                checked={form.rememberMe}
                                onChange={handleCheckboxChange}
                                className="w-3 h-3 mr-2"
                              />
                              <label htmlFor="rememberMe" 
                              className="text-sm font-nunito text-gray-500">
                                Remember Me
                              </label>
                            </div>
                            {/* Sign In Button */}
                            <div className="w-full">
                                <button
                                  type="submit"
                                  className={`${buttonClass} w-full`}
                                  data-cy="signin"
                                >
                                  Sign in
                                </button>
                            </div>
                            {/* Forgot Password */}
                            <div className="w-full text-center">
                                <p
                                    onClick={() => setShowForgotPassword(true)}
                                    className="text-sm text-gray-500 hover:underline font-nunito cursor-pointer"
                                    data-cy="forgotpasswordlink"
                                >
                                    Forgot your password?
                                </p>
                            </div>
                          </form>
                      )}
                </div>
                <div className="w-full flex justify-between items-center">
                    <p className="text-sm text-gray-500 font-nunito"> Don't have an account? </p>
                    <button
                      type="register"
                      className={`${buttonClass} pl-4 pr-4 `}
                      onClick={handleRegistration}
                    >
                      Sign Up
                    </button>
                    {showRegistration && (
                        <CandidateRegistration
                          closeModal={() => {
                            setShowRegistration(false);
                          }} email={form.email}
                        />
                      )}
                    {showForgotPassword && (
                        <ForgotPassword
                          closeModal={() => {
                            setShowForgotPassword(false);
                          }}
                        />
                      )}
                </div>
          </div>
      </div>
    </div>
  );
};

export default CandidateLogin;
